module.exports = __webpack_public_path__ + "img/assy.7ae5acd2.png";